import { useQuery } from 'react-query'
import { getDeviceFingerprint } from '../components/Controllers/CommonController'

export const useFingerprint = () => {
  const { data } = useQuery('fingerprint', getDeviceFingerprint)
  return { visitorId: data?.visitorId }
}
